// extracted by mini-css-extract-plugin
export default {"root":"classes_root__wbK3n","left-side-menu":"classes_left-side-menu__pytrg","body":"classes_body__bfrrt","content":"classes_content__oIBEd"};